<template>
    <div class="dashboard-page bold tablec">
        <div class="page-top-line">
            <h2 class="page-title">Countries - <span class="fw-semi-bold">Management</span></h2>
        </div>
        <Widget title="List of countries" :fetchingData="isReceiving">
            <b-button variant="success" v-if="hasRootRole()"
                      @click="$router.push(`/app/admin-console/countries/create`)" class="mb-3">
                Create new country
            </b-button>

            <div class="list-group list-group-lg">
                <div class="list-group-item display-flex" v-for="country in countries" :key="country.id" >
                    <div style="width:70%" class="pt-2">
                        <h5 class="">
                            [{{country.code}}] {{country.name}}
                        </h5>
                    </div>
                    <div class="ml-auto" v-if="hasRootRole()">
                        <span class="glyphicon glyphicon-pencil icon-button"
                              @click="$router.push(`/app/admin-console/countries/` + country.id)"/>
                    </div>
                </div>
            </div>
        </Widget>
    </div>
</template>

<script>
  import AddCountry from "./AddCountry";

  import {mapActions, mapState} from 'vuex';
  import Widget from '../../../components/Widget/Widget';
  import Loader from '../../../components/Loader/Loader';

  export default {
    name: "CountriesManagement",
    data() {
      return {
        popovers: {}
      }
    },
    components: {Widget, Loader, AddCountry},
    mounted() {
      // if(this.countries.length == 0) {
        this.getCountriesRequest();
      // }

    },
    computed: {
      ...mapState("auth", ["currentUser"]),
      ...mapState("countries", ["countries", "isReceiving"]),
    },
    methods: {
      ...mapActions("countries", ["getCountriesRequest"]),
      closePopover(id) {
        this.popovers[id] = false;
      },
      hasRootRole(){
        const user = this.currentUser ? this.currentUser : this.user;
        if(user) {
          const userAuthorities = user.userAuthorities;
          const rootRole = userAuthorities.filter(a => a.role == 'ROLE_ROOT');
          if (rootRole.length > 0) {
            return true;
          }
        }
        return false;
      },
    }
  }
</script>

<style src="./CountriesManagement.scss" lang="scss">

</style>
